/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Les_Start_Api_Errors_Les_Not_ActiefInputs */

const nl_les_start_api_errors_les_not_actief = /** @type {(inputs: Les_Start_Api_Errors_Les_Not_ActiefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze les is niet (meer) actief. Ververs de pagina om de actuele status te zien.`)
};

/**

* @param {Les_Start_Api_Errors_Les_Not_ActiefInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const les_start_api_errors_les_not_actief = /** @type {((inputs?: Les_Start_Api_Errors_Les_Not_ActiefInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Les_Start_Api_Errors_Les_Not_ActiefInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_les_start_api_errors_les_not_actief(inputs)
});
export { les_start_api_errors_les_not_actief as "les.start.api_errors.les_not_actief" }